/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schoolname1Inputs */

const de__field_schoolname1 = /** @type {(inputs: _Field_Schoolname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schule`)
};

/**

* @param {_Field_Schoolname1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schoolname1 = /** @type {((inputs?: _Field_Schoolname1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schoolname1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schoolname1(inputs)
});
export { _field_schoolname1 as "_field_schoolName" }